import ScrollReveal from 'scrollreveal';

document.addEventListener("DOMContentLoaded", code);
function code(event) {
	
	ScrollReveal({duration: 1000, distance: '25px', origin: 'left'}).reveal('.timeline .timeline-event:nth-child(odd) > div', {afterReveal: reset_event});
	ScrollReveal({origin: 'right'}).reveal('.timeline .timeline-event:nth-child(even) > div', {afterReveal: reset_event});

	function reset_event(event) {
		event.style.transform = null;
		event.style.transition = null;

		event.classList.add('revealed');
	}
}